import React from 'react';

import { ContentPicker } from '@lumapps/content-picker/components/ContentPicker';
import { ContentPickerDialogProps } from '@lumapps/content-picker/types';
import { ContentTypes } from '@lumapps/content-types/types';
import { useTranslate } from '@lumapps/translations';

import { USER_DIRECTORY_PICKER } from '../../keys';

export type UserDirectoryPickerProps = ContentPickerDialogProps;

const fetchParamsOverrides = {
    type: [ContentTypes.USER_DIRECTORY],
};

/**
 * User directory picker dialog
 * @family Pickers
 * @param UserDirectoryPickerProps
 * @returns UserDirectoryPicker
 */
export const UserDirectoryPicker: React.FC<UserDirectoryPickerProps> = (props) => {
    const { translateKey } = useTranslate();

    const { fetchParamsOverrides: propsFetchParamsOverrides, ...otherProps } = props;

    const mergedFetchParamsOverrides = React.useMemo(
        () => ({ ...propsFetchParamsOverrides, ...fetchParamsOverrides }),
        [propsFetchParamsOverrides],
    );

    return (
        <ContentPicker
            fetchParamsOverrides={mergedFetchParamsOverrides}
            title={translateKey(USER_DIRECTORY_PICKER.PICK_USER_DIRECTORY)}
            enabledFilters={['instances', 'author']}
            {...otherProps}
        />
    );
};
